// extracted by mini-css-extract-plugin
module.exports = {"container":"TAInputSave_container__7Ezi_","input":"TAInputSave_input__CX304","buttonContainer":"TAInputSave_buttonContainer__2mExg"};